export default {
    'title.accountCreation'             : 'Spordle Gateway | Création de compte',
    'title.payment'                     : 'Spordle Gateway | Paiement',
    'title.loading'                     : 'Chargement...',
    'title.cart.title'                  : 'Panier',
    'title.review.title'                : 'Sommaire',
}